import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import {
  CementEmissionQualifyingParams,
  cementEmissionQualifyingParamsSchema
} from '@/shared/api/EmissionQualifyingParamsModel'
import { UnitLabel } from '@/shared/config/config'
import { isValidPercentage, NumericInputGroup } from '@/common'

type FormState = {
  QPD02: {
    value: number | null
  }
}

export default function CementQualifyingParamsForm({
  qualifyingParams,
  setQualifyingParams
}: {
  qualifyingParams: CementEmissionQualifyingParams
  setQualifyingParams: (params: CementEmissionQualifyingParams) => void
}) {
  const { t } = useTranslation()

  const [formState, setFormState] = useState<FormState>({
    QPD02: {
      value: qualifyingParams.QPD02?.value || null
    }
  })

  const onNumericInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.target
    setFormState({
      ...formState,
      [name]: {
        value: value ? parseFloat(value) : null
      }
    })
  }

  const qpd2 = (
    <NumericInputGroup
      label={t('emissionQualifyingParams:fields.QPD02.label')}
      hint={t('emissionQualifyingParams:fields.QPD02.hint')}
      value={formState.QPD02.value?.toString() || ''}
      name="QPD02"
      onChange={onNumericInputChange}
      suffix={UnitLabel.percent}
      numericFormat={{
        decimalScale: 3,
        isAllowed: isValidPercentage
      }}
    />
  )

  useEffect(() => {
    const validationResult = cementEmissionQualifyingParamsSchema.safeParse(formState)

    if (validationResult.success) {
      setQualifyingParams(validationResult.data)
    }
  }, [formState])

  return (
    <div className="space-y-4">
      <ul className="grid grid-cols-2 gap-4">
        <div className="space-y-2">{qpd2}</div>
      </ul>
    </div>
  )
}
